export default __webpack_public_path__ + "static/media/Nidhi-1.34cf0097.jpg";